import React, { useState, useRef, useEffect } from 'react';
import { Box, Button } from "@mui/material";
import styles from "../styles";

/**
 * Represents a code input component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.textareaRef - The reference to the textarea element.
 * @param {boolean} props.showCode - Flag indicating whether to show the code input.
 * @param {Function} props.handleShowCode - The function to handle showing the code input.
 * @param {Function} props.setUpdateCode - The function to set the update code flag.
 * @returns {JSX.Element} The code input component.
 */
const CodeInput = ({ textareaRef, showCode, handleShowCode, setUpdateCode }) => {
    const [textareaContent, setTextareaContent] = useState(textareaRef ? textareaRef.value : '');
    const [rows, setRows] = useState(20);
    const localTextRef = useRef(null);

    useEffect(() => {
        if (textareaContent) {
            const rows = textareaContent.split('\n').length;
            setRows(rows);
        }
    }, []);

    const handleUpdateText = () => {
        setTextareaContent(localTextRef.current.value);
    };

    const handleUpdateDiagram = () => {
        textareaRef.value = localTextRef.current.value;
        setUpdateCode(true);
    };

    return (
        <Box>
            {showCode &&
                <Box>
                    <Button variant="contained" onClick={() => handleUpdateDiagram()}>Update Diagram</Button>
                    <Button variant="contained" onClick={() => handleShowCode(false)}>Close</Button>
                    <textarea style={{ width: '100%', fontSize: '12px', height: `20em` }} ref={localTextRef} value={textareaContent} onChange={() => handleUpdateText()} />
                </Box>
            }
        </Box>
    );
};

export default CodeInput;
